import { ApiError } from '../api/client';

/**
 * The human sentence to show for a failed request. Shared rather than copied so
 * the wave dialogs and the activate dialog cannot drift — an `ApiError` already
 * carries the ADR-007 envelope's `error.message`, which is written for an
 * operator; falling back to a status code is the last resort, not the default.
 */
export function errorText(err: unknown): string {
  if (err instanceof ApiError) return err.message || `Request failed (${err.status}).`;
  if (err instanceof Error) return err.message;
  return 'Unexpected error.';
}
